import * as React from 'react';
import { Logbog } from '../../models/Logbog';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Form, Row, Col, Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Section } from '../../uiComponents/layout/Section';
import { TextFormGroup, TextAreaFormGroup } from '../../uiComponents/input/FormGroups';
import LogbogAfsnitComponent from './LogbogAfsnitComponent';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { LinkSecondaryButton, AddContentButton } from '../../uiComponents/input/Buttons';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { Modal } from '../../uiComponents/layout/Modal';
import { SectionDivider } from '../../uiComponents/layout/SectionDivider';

export interface LogbogCreateUpdateProps {
    logbog: Logbog;
    errorMessages: ValidationError[];
    isSubmitting: boolean;
    isNew: boolean;
    onLogbogChanged: (fieldName: string, value: any) => void;
    onAfsnitChanged: (fieldName: string, value: any, index: number) => void;
    onLogbogSave: () => void;
    onLogbogDelete: () => void;
    addAfsnit: () => void;
    removeAfsnit: (index: number) => void;
}

class LogbogCreateUpdate extends React.Component<LogbogCreateUpdateProps, any> {
    constructor(props: LogbogCreateUpdateProps) {
        super(props);

        this.getAfsnit = this.getAfsnit.bind(this);
        this.getSubmitBtnText = this.getSubmitBtnText.bind(this);
    }

    getTitle() {
        return this.props.isNew ? 'Opret logbog' : 'Redigér logbog';
    }

    getAfsnit() {
        if (this.props.logbog.logbogAfsnit !== undefined) {
            return this.props.logbog.logbogAfsnit.map((k, i) =>
                (
                    <LogbogAfsnitComponent
                        logbogAfsnit={k}
                        key={i}
                        index={i}
                        onAfsnitChanged={this.props.onAfsnitChanged}
                        errorMessages={this.props.errorMessages}
                        removeLogbogAfsnit={this.props.removeAfsnit}
                    />
                ));
        }

        return [];
    }

    getSubmitBtnText() {
        return this.props.isNew ? 'Opret' : 'Gem';
    }

    getButtons() {
        return !this.props.isNew ? <Button buttonType='secondary' dataToggle='modal' dataTarget='#erDuSikker'>Slet logbog</Button> : undefined;
    }

    getModal() {
        return !this.props.isNew ? (
            <Modal id='erDuSikker' alert={true} excludeCancel={true} text='Ønsker du at slette denne logbog?' >
                <Button buttonType='primary' onClick={this.props.onLogbogDelete} dataDismiss='modal'>Slet</Button>
            </Modal>
        ) : undefined;
    }

    render() {
        return (
            <div>
                <SectionGroup header={this.getTitle()} buttons={this.getButtons()}>
                    <Form onSubmit={this.props.onLogbogSave}>
                        <Section>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <TextFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Titel på logbog*'
                                        name='titel'
                                        placeholder='Skriv titel'
                                        value={this.props.logbog.titel}
                                        onChange={this.props.onLogbogChanged}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <TextAreaFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Beskrivelse'
                                        name='beskrivelse'
                                        placeholder='Skriv beskrivelse'
                                        value={this.props.logbog.beskrivelse}
                                        onChange={this.props.onLogbogChanged}
                                    />
                                </Col>
                            </Row>
                        </Section>                        
                        <SectionDivider />
                        {this.getAfsnit()}
                        <Section>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <AddContentButton text={'Tilføj afsnit'} buttonOnClick={this.props.addAfsnit} />
                                </Col>
                            </Row>
                        </Section>
                        <ButtonSection>
                            <LinkSecondaryButton className='spacer' url={'/logboeger'} text='Fortryd' />
                            <SubmitButton isSubmitting={this.props.isSubmitting}>{this.getSubmitBtnText()}</SubmitButton>
                        </ButtonSection>
                    </Form>
                </SectionGroup>
                {this.getModal()}
            </div>
        );
    }
}

export default LogbogCreateUpdate;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Logbog/LogbogCreateUpdate.tsx